import React from 'react';
import {
  Paper,
  Modal,
  Backdrop,
  Fade,
  Button,
  Grid,
  TextField,
  Tooltip,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: 'none',
    boxShadow: 'none',
    outline: 'none',
    '&:focus': { outline: 'none' },
  },
  paper: {
    backgroundColor: '#212227',
    boxShadow: theme.shadows[5],
    color: 'white',
    width: '480px',
    maxWidth: '90%',
  },
  mainContainer: {
    width: '100%',
    height: '100%',
    padding: '40px 40px',
  },
  textField: {
    boxShadow: 'none !important',
    '-webkit-appearance': 'none',
  },
  buttonGrid: {
    width: '100%',
    marginTop: '30px',
  },
}));

export default function RejectVideoModal(props) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [reason, setReason] = React.useState('');

  const { onReject, videoUrl } = props;

  const handleOpen = () => {
    setOpen(true);
    setReason('');
  };

  const handleClose = () => {
    setOpen(false);
    setReason('');
  };

  const handleConfirm = () => {
    if (!reason.trim()) {
      alert('请填写拒绝原因');
      return;
    }
    onReject(reason);
    handleClose();
  };

  return (
    <div>
      <Tooltip title="reject url" placement="top">
        <button type="button" className="small-btn" onClick={handleOpen}>
          <i className="fa fa-times" style={{ color: "#fff" }} />
        </button>
      </Tooltip>
      <Modal
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 500 }}
      >
        <Fade in={open}>
          <Paper className={classes.paper}>
            <Grid container direction="column" justify="flex-start" alignItems="flex-start">
              <Grid container justify="space-around" align="flex-start" direction="column" className={classes.mainContainer}>
                <Grid style={{ marginBottom: 16 }}>
                  <div>Link:</div>
                  <a href={videoUrl} target="_blank" rel="noopener noreferrer" style={{ color: '#42b1d4' }}>{videoUrl}</a>
                </Grid>
                <Grid>
                  <TextField
                    label="Reason"
                    type="text"
                    rows={3}
                    onChange={e => setReason(e.target.value)}
                    className={classes.textField}
                    value={reason}
                    fullWidth
                  />
                </Grid>
                <Grid container className={classes.buttonGrid} direction="row" justify="space-between" alignItems="center">
                  <Grid>
                    <Button
                      color="secondary"
                      variant="contained"
                      onClick={handleConfirm}
                      disabled={!reason.trim()}
                    >
                      Confirm
                    </Button>
                  </Grid>
                  <Grid>
                    <Button onClick={handleClose}>Cancel</Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </Fade>
      </Modal>
    </div>
  );
}